import { FocusTrapper, FocusTrapperFactory } from '../../../components/focus/focus-trapper-factory';

export class MobileFlyoutMenuNavContainer {
  private focusTrapper: FocusTrapper = undefined;

  constructor(private overlayElement: HTMLElement, private focusTrapperFactory: FocusTrapperFactory) {
    this.focusTrapper = this.focusTrapperFactory.create(this.overlayElement, { autoFocus: true });
    this.focusTrapper.savePreviouslyFocusedElement();
    this.focusTrapper.autoFocusFirstTabbableElement();
  }

  destroy(): void {
    this.focusTrapper.returnFocusAfterClose();
    this.focusTrapper.destroy();
  }
}
